import axios from "axios";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import Url from "../../Url";
import { JwtTokenAuthBody, LoginRes } from "./Model";
import { headers } from "../../components/Utility";

type InitialState = {
  loading: boolean;
  jwtAuthenticationRes: LoginRes;
  successMsg: string;
  errorMsg: string;
  status: 0;
};
const initialState: InitialState = {
  loading: false,
  jwtAuthenticationRes: {} as LoginRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};

export const jwtAuthentication = createAsyncThunk<LoginRes, JwtTokenAuthBody>(
  "jwtAuthentication/jwtAuthentication",
  async (payload: JwtTokenAuthBody, { rejectWithValue }) => {
    return await axios
      .post(Url.apiURL + "/api/token/", payload, { headers })
      .then((response) => {
        localStorage.setItem("access", response.data.access);
        localStorage.setItem("refresh", response.data.refresh);
        return response.data;
      })
      .catch((error) =>
        rejectWithValue(
          error.response.data.non_field_errors[0] ||
            error.response.message ||
            "Something went wrong"
        )
      );
  }
);

const jwtAuthenticationSlice = createSlice({
  name: "jwtAuthentication",
  initialState,
  reducers: {
    updateSetEmailOrPhoneResMsg: (state) => {
      state.successMsg = "";
      state.errorMsg = "";
    },
    clearSetEmailOrPhoneAPIRes: (state) => {
      state.successMsg = "";
      state.errorMsg = "";
      state.jwtAuthenticationRes = {} as LoginRes;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(jwtAuthentication.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      jwtAuthentication.fulfilled,
      (state, action: PayloadAction<LoginRes>) => {
        state.loading = false;
        state.jwtAuthenticationRes = action.payload;
        state.successMsg = "JWT authentication Successful";
        state.errorMsg = "";
      }
    );
    builder.addCase(jwtAuthentication.rejected, (state, action) => {
      state.loading = false;
      state.jwtAuthenticationRes = {} as LoginRes;
      state.successMsg = "";
      state.errorMsg = String(action.payload!);
    });
  },
});
export const { updateSetEmailOrPhoneResMsg, clearSetEmailOrPhoneAPIRes } =
  jwtAuthenticationSlice.actions;
export default jwtAuthenticationSlice.reducer;
